import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userService, UpdateUserPayload } from '@services/user';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateUser = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['users', 'update'],
    mutationFn: async (payload: UpdateUserPayload) => {
      return await userService.updateUser(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success(tActionMessages.userUpdatedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Update user error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to update user';
      toast.error(errorMessage);
    },
  });
};

export default useUpdateUser;